import "./UpgradeTooltip.styles.scss";
import React, { useState } from "react";
import { Button, ImageSeparator } from "components";
import PartyIcon from "assets/icons/party-horn.svg";
import UpgradeSplash from "assets/images/splashes/splash-1.png";
import ReactTooltip from "react-tooltip";
import { useCurrentUser } from "utils/hooks";
import PlanSelection from "components/elements/PlanSelection/PlanSelection";

interface UpgradeTooltipProps {
  tooltipId: string;
  heading?: string;
  limitedEntity: string;
  warningLine?: string;
  valueLine?: string;
  ctaText?: string;
  offset?: any;
}

const UpgradeTooltip = ({
  tooltipId,
  offset,
  heading,
  limitedEntity,
  warningLine,
  valueLine,
  ctaText,
}: UpgradeTooltipProps) => {
  const { user } = useCurrentUser();
  const [showPlanSelection, setShowPlanSelection] = useState(false);

  const handleUpgradeButton = () => {
    setShowPlanSelection(true);
  };

  const handlePlanSelected = () => {
    setShowPlanSelection(false);
    // The plan selection component will handle the redirect to Stripe
  };

  const handleCancelPlanSelection = () => {
    setShowPlanSelection(false);
  };

  if (showPlanSelection) {
    return (
      <div className="upgrade-tooltip-modal">
        <PlanSelection
          organizationId={user?.activeOrganizationId || ""}
          onPlanSelected={handlePlanSelected}
          onCancel={handleCancelPlanSelection}
        />
      </div>
    );
  }

  return (
    <ReactTooltip
      className="upgrade-tip"
      id={tooltipId}
      place="bottom"
      type="light"
      effect="solid"
      delayHide={4000}
      clickable
      eventOff="click"
      offset={offset || { left: 80 }}
    >
      <div className="upgrade-tip__content">
        <h2>{heading || "Unlock more!"}</h2>
        <p>
          {warningLine ||
            `You've reached the limit of how many ${limitedEntity} you can add
          on your current plan.`}
        </p>
        <p>
          {valueLine ||
            `Upgrade your account to add additional ${limitedEntity} and more!`}
        </p>
        <ImageSeparator image={UpgradeSplash} alt="upgrade icon" />
        <Button
          name="upgrade_button"
          value={ctaText || "Upgrade now"}
          pill
          fullWidth
          icon={PartyIcon}
          onClick={handleUpgradeButton}
        />
      </div>
    </ReactTooltip>
  );
};

export default UpgradeTooltip;
